import Vue, { VueConstructor } from 'vue';
import { componentFactory } from 'vue-tsx-support';
import { useModule } from 'vuex-simple';

import { JtnUiTypography } from '@jtnews/jtn-ui';
import { injectStylesMixin, tsStoreMixin } from '@jtnews/shared';

import { RecordModule, RECORD_MODULE_NAMESPACE } from '../../store';

import styles from './record-forum-button.styles.scss?module';

const baseBlock = Vue as VueConstructor<Vue & { checkBlockVisible: Vue | null }>;

export default componentFactory
  .extendFrom(baseBlock)
  .mixin(tsStoreMixin)
  .mixin(injectStylesMixin(styles))
  .create({
    name: 'RecordForumButton',
    props: {
      title: {
        type: String,
        default: 'Обсудить на форуме'
      }
    },
    data() {
      return {
        obsHalfOptions: {
          callback: this.checkBlockVisible,
          once: true,
          intersection: {
            threshold: 1
          }
        },
        buttonData: null
      };
    },
    computed: {
      recordModule(): RecordModule | undefined {
        return useModule<RecordModule>(this.$store, RECORD_MODULE_NAMESPACE);
      },
      isCommentsAllowed(): boolean {
        return this.store.layoutModule.record?.data?.isCommentsAllowed || false;
      },
      recordId(): number {
        return Number(this.$route.params.id);
      },
      buttonText(): string {
        return this.buttonData?.count > 0
          ? `${this.title} (${this.buttonData.count})`
          : this.title;
      },
      buttonUrl(): string {
        return this.buttonData?.url ?? '';
      },
      showedButton(): boolean {
        return this.isCommentsAllowed && this.buttonUrl.length > 0;
      }
    },
    watch: {
      recordId(newValue, oldValue) {
        if (newValue !== oldValue && this.isCommentsAllowed) {
          void this.fetchForumData();
        }
      }
    },
    mounted() {
      void this.fetchForumData();
    },
    methods: {
      async fetchForumData() {
        try {
          const { data } = await this.recordModule?.getRecordForumsData(this.recordId);
          this.buttonData = data;
          // eslint-disable-next-line
        } catch (err) {}
      },
      checkBlockVisible(isVisible: boolean) {
        if (isVisible) {
          this.sendNewReachGoal('Просмотр', 'viewForumDisc');
        }
      },
      toForums() {
        this.sendNewReachGoal('Переход на форум', 'clickForumDisc');
      },
      sendNewReachGoal(valueName: string, goalName: string) {
        const blockType = 'Центральная колонка';
        const fieldType = this.title;

        this.store.analyticsModule.sendNewReachGoal({
          blockType,
          fieldType,
          valueName,
          goalName
        });
      }
    },
    render() {
      return (
        this.showedButton && (
          <div
            v-observe-visibility={this.obsHalfOptions}
            class={styles['record-forum-button']}
          >
            <JtnUiTypography
              href={this.buttonUrl}
              tag="a"
              type="font-vijet-type-1"
              link-type="link-blue"
              target="_blank"
              onClick={this.toForums}
            >
              {this.buttonText}
            </JtnUiTypography>
          </div>
        )
      );
    }
  });
